import Confirm from '@/components/Confirm'

export default {
  data() {
    return {
      confirmActive: false
    }
  },

  components: {
    Confirm
  },

  methods: {
    activateConfirm() {
      this.confirmActive = true
    },

    cancel() {
      this.confirmActive = false
    }
  }
}
